export default {"src":"/_next/static/media/privateChat.03fb901d.svg","height":11,"width":14,"blurWidth":0,"blurHeight":0};